import { useState } from "react";
import { useAsync } from "react-async";
import { getUnreadMessages } from "../../../../api/services/messageService";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";
import MessageDisplay from "../../../../api/models/messageDisplay";
import { getPendingInvoiceApprovals, getTsFlagsByDirectorUserId } from "../../../../api/services/timesheetService";
import Spinner from "../../../spinner";
import DataLink from "../../../DataLink";
import { useDispatch } from "react-redux";
import { updateUnreadMessagesCount } from "../../../../slices/userSlice";
import DOMPurify from 'dompurify';

const DashboardWidgetDirectorNotifications = ({ discipline, user }: DashboardProps): JSX.Element => {
    const [messages, setMessages] = useState<MessageDisplay[]>([]);
    const [tsFlagsCount, setTsFlagsCount] = useState<number>(0);
    const [proofingCount, setProofingCount] = useState<number>(0);
    const id: number = user.userId!;
    const dispatch = useDispatch();

    const asyncMessages = useAsync({
        promiseFn: getUnreadMessages, id,
        onResolve: (r) => {
            const sanitizedMessages = r.data.messages.map(message => ({
                ...message,
                messageText: DOMPurify.sanitize(message.messageText)
            }));

            setMessages(sanitizedMessages)
            dispatch(updateUnreadMessagesCount(r.data?.messages?.length ?? 0))
        }
    });

    const asyncTsFlags = useAsync({
        promiseFn: getTsFlagsByDirectorUserId,
        onResolve: (response: any) => setTsFlagsCount(response.data)
    });

    const asyncTs = useAsync({
        promiseFn: getPendingInvoiceApprovals,
        onResolve: (response) => setProofingCount(response.data.length)
    });

    return (
        <>
            <div className={DashboardPropsDefaults.containerClassNames}>
                <div className="pb-1 dashboard-widget-title">
                    <h3>Notifications</h3>
                </div>
                <div className={DashboardPropsDefaults.contentClassNames}>
                    <Spinner show={(asyncMessages.isPending || asyncTsFlags.isPending || asyncTs.isPending)} />
                    {!(asyncMessages.isPending || asyncTsFlags.isPending || asyncTs.isPending) && (<>
                        <div>You Have <DataLink href="/messages" className="mb-2">{messages.length}</DataLink> Unread Messages</div>
                        <div>Timesheet Flags To Be Proofed&nbsp;
                            <span className="mb-2 text-sm underline cursor-pointer hover:no-underline">
                                (<DataLink href="/proofing">{tsFlagsCount}</DataLink>)
                            </span>
                        </div>
                        <div>Invoice Approvals Needed&nbsp;
                            <span className="mb-2 text-sm underline cursor-pointer hover:no-underline">
                                (<DataLink href="/accounting/invoice">{proofingCount}</DataLink>)
                            </span>
                        </div>
                    </>)}
                </div>
            </div>
        </>
    );
};

export default DashboardWidgetDirectorNotifications;
